<div class="page-content" *ngIf="!timerService.isForwarding">

     <div [hidden]="data.isNextChild">
            <button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button>
     </div>

     <h1 class="page-title" translate>
      {{ "about_the_child_main.page_title" }}
     </h1>

     <p class="page-title" translate>
      {{ "about_the_child_main.in_this_section" }}
     </p>

     <h2 class="page-title" translate>
      {{ "about_the_child_main.child.name" }}
     </h2>

     <form>
      <!--  ***** Child's Name Start ****  -->
      <div id="childName">
     <ng-input [(ng-model)]="aboutChild.name.first" size="50" max="50" margin="/0.5" id="childFirstName"
               alt-text='about_the_child_main.child.first_name_alt'
               [(ng-error)]="error_childFirstName"
               [ng-disable]="aboutChild.name.chk_singleName=='Y'"> 
     {{'about_the_child_main.child.first_name'}}
     </ng-input>
     
     <ng-input [(ng-model)]="aboutChild.name.middle" size="50" margin="/0.5" max="50" id="childMiddleName"
               alt-text='about_the_child_main.child.middle_name_alt'
               [(ng-error)]="error_childMiddleName"
               [ng-disable]="aboutChild.name.chk_middleNA || aboutChild.name.chk_singleName=='Y'"> 
      {{'about_the_child_main.child.middle_name'}}
      </ng-input>

      <ng-checkbox [(ng-model)]="aboutChild.name.chk_middleNA" margin="/0.5"  
                   [(ng-clear)]="error_childMiddleName"    (change)="aboutChild.name.middle=''"
                   [ng-disable]="aboutChild.name.chk_singleName=='Y'">
      {{'about_the_child_main.child.middle_name_notapplicable'}}
      </ng-checkbox>
   
      <ng-input [(ng-model)]="aboutChild.name.last" size="50" margin="/0.5" max="50" id="childLastName"
                alt-text='about_the_child_main.child.last_name_alt'
                [(ng-error)]="error_childLastName"
                [ng-disable]="aboutChild.name.chk_singleName=='Y' || aboutChild.isParentAgreeOnLastName == 'N'"> 
      {{'about_the_child_main.child.last_name'}}
      </ng-input>
      </div>
      <accordion label="about_the_child_main.accord_canIUseAccents.header" outer-class="bottom-margin">
            <div class="page-title" style="margin-bottom: 0.6em;" translate='about_the_child_main.accord_canIUseAccents.text1'></div>
            <div class="page-title" style="margin-bottom: 0.6em;" translate ='about_the_child_main.accord_canIUseAccents.text2'>
                  <a-link (click)=onMyClick($event)
                      alt-text="about_the_child_main.accord_canIUseAccents.alt"
                      label='about_the_child_main.accord_canIUseAccents.link'>
                  </a-link>
                  <span translate='about_the_child_main.accord_canIUseAccents.text2_2'></span>
            </div>  
            <div class="page-title" translate='about_the_child_main.accord_canIUseAccents.text3'></div> 
      </accordion>
      <light-box input-class="white-box">
            <div style="padding-bottom: 0.5em;">
                  <header-x (close)="onMyClose()"></header-x>
            </div>
            
            <h2 class="page-title"  translate='FAQ.letters_with_accents.title'></h2>
            
            <div class="page-title" translate='FAQ.letters_with_accents.text'></div>

            <div class="div-tab">
                  <div class="div-row" colspan="2">
                        <div class="div-header">
                              <strong translate='FAQ.letters_with_accents.character'></strong>
                  </div>
                        <div class="div-header2">
                              <strong translate='FAQ.letters_with_accents.press_alt'></strong>
                  </div>
                    </div>
                  <div class="div-row">
                      <div class="div-col">à</div>
                      <div class="div-col2">133</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">â</div>
                        <div class="div-col2">131</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ä</div>
                        <div class="div-col2">132</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ç</div>
                        <div class="div-col2">135</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">Ç</div>
                        <div class="div-col2">128</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">é</div>
                        <div class="div-col2">130</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">É</div>
                        <div class="div-col2">144</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">è</div>
                        <div class="div-col2">138</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ê</div>
                        <div class="div-col2">136</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ë</div>
                        <div class="div-col2">137</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">î</div>
                        <div class="div-col2">140</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ï</div>
                        <div class="div-col2">139</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ô</div>
                        <div class="div-col2">147</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ö</div>
                        <div class="div-col2">148</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ù</div>
                        <div class="div-col2">151</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">û</div>
                        <div class="div-col2">150</div>
                  </div>
                  <div class="div-row">
                        <div class="div-col">ü</div>
                        <div class="div-col2">129</div>
                  </div>
            </div>
      </light-box>
     <div  [hidden]="parentCount == 1 || isCustodyOtherThanParent || aboutChild.name.chk_singleName=='Y'" name="isParentAgree" class="padding-bottom-1em">
      <br/>
     <ng-radio [(ng-model)]="aboutChild.isParentAgreeOnLastName"  id="isParentAgreeRadio" 
               [(ng-error)]="error_parentsAgree"
               [(ng-clear)]="error_childLastName"
               [item-list]="items.yesNoList"
               [ng-disable]="aboutChild.name.chk_singleName=='Y' || parentCount == 1 || isCustodyOtherThanParent"
               (change)="isParentAgreeChange()">
      {{'about_the_child_main.parentsAgree'}}
     </ng-radio>
     </div>
     
     <div  [hidden]="!(aboutChild.isParentAgreeOnLastName === 'N') || parentCount == 1 || aboutChild.name.chk_singleName=='Y'" id="parentAgree">
      
      <information>
            <h2 class="page-title" translate>
            {{ "about_the_child_main.parents_dont_agree_cn_information" }}
            </h2>     
            <div translate class="margin-bottom">
                  {{'about_the_child_main.parents_dont_agree_cn_information_text1'}}
            </div>
            <div translate>
                  {{'about_the_child_main.parents_dont_agree_cn_information_text2'}}
            </div>
      </information>
      
      <div id="parentNameInput" style="height:1px">&nbsp;</div>
      <div *ngFor="let p of parents; let i = index">            
            <ng-input [hidden]="i>=1" id="motherLastName"
                      [(ng-model)]="parents[0].name.last" size="50" max="50"
                      alt-text="about_the_child_main.parentCurLastName_title$"
                      [(ng-error)]="error_parentCurLastName"
                      (blur)="parentsNameLength($event, 0)"
                      label='about_the_child_main.parentCurLastName_surro$'
                      [if]="isSurrogate"> 

            </ng-input>
            
            <ng-input [hidden]="i==0" id="parentLastName{{i}}"
                      [(ng-model)]="parents[i].name.last" size="50" max="50"
                      alt-text="about_the_child_main.nextParentCurLastName_title$"
                      [(ng-error)]="errorLastName[i]"
                      (blur)="parentsNameLength($event, i)"
                      label='about_the_child_main.nextParentCurLastName_surro$'
                      [if]="isSurrogate"> 
             </ng-input>
      </div>
      
      <br/>
      <div aria-live='assertive'>
      <div [hidden]="!checknamesLength()">
      <notice-box>
            <div translate='about_the_child_main.critical_notice1_text1' class="margin-bottom"></div>
            <div translate='about_the_child_main.critical_notice1_text2'>
                    <a  (click)="goORGContact()" style="cursor:pointer;"
                        alt-text='about_the_child_main.critical_notice1_link_alt'
                       translate='about_the_child_main.critical_notice1_link_label'></a>
                  <span translate='about_the_child_main.critical_notice1_text3'></span>
            </div>
      </notice-box> <br/>
      </div>
      </div>
      <information>
            <h2 class="page-title" translate>
                  {{ "about_the_child_main.please_note_information" }}
            </h2>     
            <div translate class="margin-bottom">{{'about_the_child_main.please_note_information_text1'}}</div>
            <div translate>{{'about_the_child_main.please_note_information_text2'}}</div>
      </information>

     </div>     

     <ng-checkbox [(ng-model)]="aboutChild.name.chk_singleName"
                   (change)="onSingleNameChange()">
                   {{'about_the_child_main.singleNameCheckbox'}}
     </ng-checkbox>
      <!--  ***** Child's Name End ****  -->

     <!--  ***** Single Name Start ****  -->
     <accordion label="about_the_child_main.accord_whatisSN.header"  
                margin="1.85|0" outer-class="bottom-margin" [(open)]="isOpenCSN">
      <div class="accord-start" translate='about_the_child_main.accord_whatisSN.text'></div>
     </accordion>
     
     <div translate [hidden]="aboutChild.name.chk_singleName!='Y'" id="singleName">

      <ng-input [(ng-model)]="aboutChild.name.single" size="50" max="50" id="childSingleName"
                alt-text='about_the_child_main.childSingleName_title'
                [(ng-error)]="error_childSingleName"> 
      {{'about_the_child_main.childSingleName'}}
      </ng-input>  

      <div  [hidden]="parentCount == 1 || isCustodyOtherThanParent"> 
      <ng-radio [(ng-model)]="aboutChild.isParentAgreeOnSingleName" id="parentAgreeSingleNameRadio"
                [(ng-error)]="error_parentsAgreeSN"
                [ng-disable]="parentCount == 1 || isCustodyOtherThanParent"
                [item-list]="items.yesNoList">
      {{'about_the_child_main.parentsAgreeSN'}}
      </ng-radio>
      <br/>
      </div>

      <information>
            <ng-container *ngTemplateOutlet="additionalDoc"></ng-container>
       </information>
  
      </div>
      
     <br/>
     <!--  ***** Single Name End ****  -->

      <!--  ***** Details about the birth Start ****  -->
     <h2 class="page-title" translate>
      {{ 'about_the_child_main.details_about_the_birth'}}
      <span [hidden]="!completed()">{{getFullName()}}</span>
     </h2>

     <div id="childGender">
     <ng-radio [(ng-model)]="aboutChild.gender" vertical id="childGenderRadio"
               [(ng-error)]="error_gender"
               [item-list]="items.genders">
               {{'about_the_child_main.sex_of_child'}}
     </ng-radio>
     
      <div [hidden]="aboutChild.gender!='U'">
            <div translate class="margin-accord">{{'about_the_child_main.accord_undetermined1'}}</div>
            <div translate class="margin-accord">{{'about_the_child_main.accord_undetermined2'}}</div>
            <div translate class="margin-accord">{{'about_the_child_main.accord_undetermined3'}}</div>
      </div>
      </div>
     
     <div id="childWeight">
     <div [hidden]="grams===false">
      <div class="row">
     <ng-input [(ng-model)]="aboutChild.grams" size="4" type="number" id="childWeightGrams"
               alt-text='about_the_child_main.grams_title'
               [(ng-clear)]="error_childs_weight"> 
                  {{'about_the_child_main.weight_at_birth'}} <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
               <div class="grams-style">
                  {{'about_the_child_main.grams' | translate}}
               </div>     
     </ng-input>
      </div>
      </div>
      <div [hidden]="poundsOunces===false">
      <div class="row">
            <div class="column">
                  <ng-input [(ng-model)]="aboutChild.pounds" size="4" max="2" type="number" id="childWeightPounds"
                            alt-text='about_the_child_main.pounds_title'
                            [(ng-clear)]="error_childs_weight"> 
                  {{'about_the_child_main.weight_at_birth'}} <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
                  <div class="pounds-style">
                        {{'about_the_child_main.pounds' | translate}}
                  </div>             
         </ng-input>
            </div>
            <div class="column2">
                  <div class="ounces-div">
                  <ng-input [(ng-model)]="aboutChild.ounces" size="4" max="2" type="number" id="childWeightOunces"
                        alt-text='about_the_child_main.ounces_title'
                        [(ng-clear)]="error_childs_weight"> 
                        <div class="ounces-style">
                              {{'about_the_child_main.ounces' | translate}}
                        </div>
                 </ng-input>
            </div>
           </div>
      </div>
      </div>
     <div  [hidden]='!error_childs_weight' class="errorWeight"><errors [error]="error_childs_weight"></errors></div>
     <div class="gramsOnces" [hidden]="grams===false"><a translate (click)="gramsPounds()">
           {{'about_the_child_main.switch_to_pounds'}}</a>
      </div>
     <div class="gramsOnces" [hidden]="poundsOunces===false"><a translate (click)="poundsGrams()">
           {{'about_the_child_main.switch_to_grams'}}</a>
      </div>
     </div> 

     <div [hidden]="data.eligibility.birthType == '1'" id="birthOrder">
      <ng-select [item-list]="items.birthOrders" id="birthOrderSelect"    
                 [(ng-error)]="error_childs_birth_order"
                 [(ng-model)]="data.aboutChild.birthOrder">
                 {{'about_the_child_main.birth_order_of'}}
                 <span [hidden]="!completed()">{{getFullName()}}</span>
      </ng-select>
      </div>

     <div id="childCityTown">
     <ng-select [(ng-model)]="aboutChild.cityTown"  size="29"  id="childCityTownSelect"
                [(ng-error)]="error_childs_city_town" 
                [item-list]="items.cityList"
                (change)="cityChange()">
      {{'about_the_child_main.city_town_child_born'}}
     </ng-select>

     <div [hidden]="!aboutChild.cityTown.startsWith('_')" style="margin-top: 1em; margin-bottom: 1em;">
            <span translate>{{'about_the_child_main.city_town_please_note1'}}</span>
            <strong [update]="aboutChild.cityTown"></strong>
            <span translate>{{'about_the_child_main.city_town_please_note2'}}</span>
     </div>
 
     <div [hidden]="aboutChild.cityTown!=NotFound">
            <ng-input [(ng-model)]="aboutChild.otherCity" size="50" max="40" id="childCityTownOther"
                      alt-text='about_the_child_main.other_city_town_title'
                      [(ng-error)]="error_otherCity"> 
            {{'about_the_child_main.other_city_town'}}
            <p [innerHTML]="'about_the_child_main.other_city_town_note' | translate"></p>
            </ng-input>  
      </div>
      </div>

      <div id="childBirthPlace">
      <ng-radio [(ng-model)]="aboutChild.birthPlaceType" id="childBirthPlaceRadio" vertical
                [(ng-error)]="error_childs_place"
                [item-list]="items.birthPlaces"
                (change)="birthPlacesChange()" >
      {{'about_the_child_main.place_child_born'}}
      </ng-radio>
      <errors [error]="error_deliveredByOtherHospital"></errors>
      <div [hidden]="aboutChild.birthPlaceType!='HO'">
            <ng-select [item-list]="hospitalList"  size="29" id="hospitalSelect"  
                       [(ng-error)]="error_hospital" 
                       [(ng-model)]="aboutChild.birthPlaceCode">
                {{ "about_the_child_main.whichhospital" }}
                <div class="note-style" [innerHTML]="'about_the_child_main.note_hospital' | translate"></div>
            </ng-select>
            <div [hidden]="aboutChild.birthPlaceCode!=NotFound">
                  <ng-input [(ng-model)]="aboutChild.otherBirthPlace" size="50" max="80" id="hospitalOther"
                            alt-text='about_the_child_main.other_hospital_title'
                            [(ng-error)]="error_otherHospital"> 
            {{'about_the_child_main.other_hospital'}}
            <div class="note-style" [innerHTML]="'about_the_child_main.other_hospital_note' | translate"></div>
            </ng-input>  
            </div>
     </div>

      <div [hidden]="aboutChild.birthPlaceType!='BC'">

            <ng-select [item-list]="birthingCentreList"  size="29" id="birthingCentreSelect" 
                [(ng-error)]="error_birthingCentre" 
                [(ng-model)]="aboutChild.birthPlaceCode">
                {{ "about_the_child_main.whichBirthingCentre" }}
                <div class="note-style"  [innerHTML]="'about_the_child_main.note_birthing_centre' | translate"></div>
            </ng-select>
            <div [hidden]="aboutChild.birthPlaceCode!=NotFound">
                  <ng-input [(ng-model)]="aboutChild.otherBirthPlace" size="50" max="80" id="birthingCentreOther"
                            alt-text='about_the_child_main.other_birthing_centre_title'
                            [(ng-error)]="error_otherBirthingCentre"> 
            {{'about_the_child_main.other_birthing_centre'}}
            <div class="note-style" [innerHTML]="'about_the_child_main.other_birthing_centre_note' | translate"></div>
            </ng-input>  
            </div>

      </div>

      <div [hidden]="aboutChild.birthPlaceType!='HM'">

            <p translate>{{ "about_the_child_main.homeBirth" }}</p>

            <ng-input [(ng-model)]="aboutChild.birthStreetNumber" size="10" id="homeStreetNumber"
                       (blur)="onStreetNumber()"
                      alt-text='about_the_child_main.streetNumber_title'
                      [(ng-error)]="error_streetNumber"> 
            {{'about_the_child_main.streetNumber'}}
            </ng-input>

            <ng-input [(ng-model)]="aboutChild.birthStreetName" size="50" max="60" id="homeStreetName"
                      alt-text='about_the_child_main.streetName_ruralRoute_title'
                      [(ng-error)]="error_streetNameRuralRoute"> 
            {{'about_the_child_main.streetName_ruralRoute'}}
            </ng-input>

      </div>

      <div [hidden]="aboutChild.birthPlaceType!='OT'">

            <p translate>{{ "about_the_child_main.address_where_birth_occurred" }}</p>

            <ng-input [(ng-model)]="aboutChild.birthStreetNumber" size="10"  id="otherStreetNumber"
                       (blur)="onStreetNumber()"
                       [(ng-error)]="error_streetNumber"
                      alt-text='about_the_child_main.streetNumber_if_applicable_title'> 
            {{'about_the_child_main.streetNumber_if_applicable'}}
            </ng-input>

            <ng-input [(ng-model)]="aboutChild.birthStreetName" size="50" max="60" id="otherStreetName"
                      alt-text='about_the_child_main.streetName_ruralRoute_Intersection_title'
                      [(ng-error)]="error_streetNameRuralRouteIntersection"> 
            {{'about_the_child_main.streetName_ruralRoute_Intersection'}}
            </ng-input>
              
      </div>
      </div>
      <br/>
     
      <div id="childAttendent">
      <ng-radio [(ng-model)]="aboutChild.attendentType" id="childAttendentRadio" vertical 
                [(ng-error)]="error_attendentType"
                [item-list]="items.attendants"
                (change)="onAttendentChange()">

            {{'about_the_child_main.who_delivered_child'}}
            <span [hidden]="!completed()">{{getFullName()}}</span>
            <span translate>{{'about_the_child_main.who_delivered_child_continue'}}</span>?
            <span [hidden]="!isCustodyOtherThanParent" translate>{{'-text.optional'}}</span>
      </ng-radio>
      <errors [error]="error_deliveredByOther"></errors>
      <div [hidden]="!aboutChild.attendentType">

            <div [hidden]="aboutChild.attendentType!='O'" translate>
                  <span style="margin-left:2.2em;" translate='about_the_child_main.attendant_someoneelse'></span>
                  <br/>
                  <addtional-doc [hidden]='!data.isNextChild'></addtional-doc>            
            </div>

            <ng-input [(ng-model)]="aboutChild.attendentTitle" size="50" max="40" margin="/1.5" id="attendentTitle"
                      alt-text='about_the_child_main.other_title_alt'
                      [(ng-error)]="error_attendentTitle"
                      [hidden]="aboutChild.attendentType!='O'"> 
            <div class="margin-bottom-ba" translate='about_the_child_main.other_title'></div>
            <div [innerHTML]="'about_the_child_main.other_example' | translate"></div>
            </ng-input>

            <p [hidden]="aboutChild.attendentType!='P'" translate>
                  {{ "about_the_child_main.name_of_physician"}}
                  <span [hidden]="!completed()">{{getFullName()}}</span>
                  <span translate>{{'about_the_child_main.who_delivered_child_continue'}}</span>
            </p>
            <p [hidden]="aboutChild.attendentType!='M'" translate>
                  {{ "about_the_child_main.name_of_midwife"}}
                  <span [hidden]="!completed()">{{getFullName()}}</span>
                  <span translate>{{'about_the_child_main.who_delivered_child_continue'}}</span>
            </p>
            <p [hidden]="aboutChild.attendentType!='O'" translate>
                  {{ "about_the_child_main.name_of_other"}}
                  <span [hidden]="!completed()">{{getFullName()}}</span>
                  <span translate>{{'about_the_child_main.who_delivered_child_continue'}}</span>
            </p>

            <ng-input [(ng-model)]="aboutChild.attendentFirstName" size="50" max="50" margin="/0.5" id="attendentFirstName" 
                      alt-text='about_the_child_main.attendant_first_name_title'
                      [(ng-error)]="error_attendantFirstName"
                      [ng-disable]="aboutChild.isDoctorSingleName=='Y' 
                      || aboutChild.isMidwifeSingleName=='Y'
                      || aboutChild.isSomeoneElseSingleName=='Y'"> 
            {{'about_the_child_main.attendant_first_name'}}
            <div [hidden]="aboutChild.attendentType!='P'" style="font-size: 16px;" translate='about_the_child_main.do_not_enter'></div>
            </ng-input>

            <ng-input [(ng-model)]="aboutChild.attendentLastName"size="50" max="50" margin="/0.5" id="attendentLastName" 
                      alt-text='about_the_child_main.attendant_last_name_title'
                      [(ng-error)]="error_attendantLastName"
                      [ng-disable]="aboutChild.isDoctorSingleName=='Y'
                      || aboutChild.isMidwifeSingleName=='Y'
                      || aboutChild.isSomeoneElseSingleName=='Y'"> 
            {{'about_the_child_main.attendant_last_name'}}
            </ng-input>

            <ng-checkbox [(ng-model)]="aboutChild.isDoctorSingleName" margin="/0.5"
                         (change)="onAttendantSingleNameChange()"
                         [hidden]="aboutChild.attendentType!='P'">
            {{'about_the_child_main.physician_single_name_checkbox'}}
            </ng-checkbox>

            <ng-checkbox [(ng-model)]="aboutChild.isMidwifeSingleName"
                         (change)="onAttendantSingleNameChange()"
                         [hidden]="aboutChild.attendentType!='M'">
            {{'about_the_child_main.midwife_single_name_checkbox'}}
            </ng-checkbox>

            <ng-checkbox [(ng-model)]="aboutChild.isSomeoneElseSingleName"
                         (change)="onAttendantSingleNameChange()"
                         [hidden]="aboutChild.attendentType!='O'">
            {{'about_the_child_main.other_single_name_checkbox'}}
            </ng-checkbox>

            <accordion label="about_the_child_main.accord_whatisSN.header" 
                       margin="1.85|0" outer-class="bottom-margin" [(open)]="isOpenASN">
                  <div class="accord-start" translate='about_the_child_main.attendant_sindle_name_accordion'></div>
            </accordion>
            <div translate [hidden]="aboutChild.isDoctorSingleName!='Y' 
                                    && aboutChild.isMidwifeSingleName!='Y'
                                    && aboutChild.isSomeoneElseSingleName!='Y'">
                  <ng-input [(ng-model)]="aboutChild.attendentSingleName" size="50" max="50" id="attendentSingleName"
                            alt-text='about_the_child_main.attendant_single_name_title'
                            [(ng-error)]="error_attendantSingleName"> 
                  {{'about_the_child_main.attendant_single_name'}}
                  </ng-input>
            </div>
      </div>
      </div>
      <!--  ***** Details about the birth End ****  -->
     </form>    

     <div class="btn-div">

          <div [hidden]="this.aboutChild.name.chk_singleName == 'Y'">
                 <button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button>
          </div>

          <div [hidden]="this.aboutChild.name.chk_singleName != 'Y'">
            <div class="button-top">
                   <button class="btn-next2" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button>
            </div>
            <div class="button-bottom">
                  <button 
                          class="btn-cancel2" title="{{Button.Cancel_alt | translate}}" (click)="onCancelApplication()" translate>
                          {{Button.Cancel}}
            </button>
            </div>
       </div>
     </div>

</div>

<ng-template id="additionalDoc" #additionalDoc>
      <h3>
           {{'about_the_child_main.additional_doc.header' | translate}}
      </h3>
      <div class="padding-top-1em" translate >
           {{ "about_the_child_main.additional_doc.text1" }}
      </div>
      <div class="padding-top-1em" translate>
            {{ "about_the_child_main.additional_doc.text2" }}
       </div>
      <div class="padding-top-1em" translate>
           {{ "about_the_child_main.additional_doc.text3" }}
      </div>
      <div class="padding-top-1em" [innerHTML]="'about_the_child_main.additional_doc.step1_header' | translate"></div>
      <div class="page-title">
            <a-link link-url="about_the_child_main.additional_doc.request_for_birth_link"
            alt-text="about_the_child_main.additional_doc.request_for_birth_title"
            label='about_the_child_main.additional_doc.step1_text1'></a-link>
      </div>
 
      <div class="padding-top-1em" [innerHTML]="'about_the_child_main.additional_doc.step2_header' | translate"></div>
      <div class="page-title">
           {{ "about_the_child_main.additional_doc.step2_text1" | translate }}
      </div>
 
      <div class="padding-top-1em" [innerHTML]="'about_the_child_main.additional_doc.step3_header' | translate"></div>
      <div class="page-title">
           {{ "about_the_child_main.additional_doc.step3_text1" | translate }}
      </div>
 
      <div class="padding-top-1em" [innerHTML]="'about_the_child_main.additional_doc.step4_header' | translate"></div>
      <div class="page-title" [innerHTML]="'about_the_child_main.additional_doc.step4_text1' | translate"></div>
 
      <div class="padding-top-1em" [innerHTML]="'about_the_child_main.additional_doc.header_note' | translate">
      </div>
      <div class="page-title" [innerHTML]="'about_the_child_main.additional_doc.note_text' | translate">
      </div>
 </ng-template>